// returns logo_engraving or text_engraving

export const getActiveEngravingSectionId = (meshEditingStatus, itemsState, componentsState) =>
  meshEditingStatus === "rear"
    ? itemsState.activeObjs[componentsState.activeId].rear?.engraving.section
    : itemsState.activeObjs[componentsState.activeId].front?.engraving.section;
